import axios from './Axios';

const path = '/payments/stripe';

export const getStripe = (body) => axios.post(`${path}/new`, body);

export default {
  getStripe,
};
